export default "__VITE_ASSET__DhGlMmG3__"